// extracted by mini-css-extract-plugin
export default {"topImage":"inAppMessage_topImage__eqR3J","bottom_text":"inAppMessage_bottom_text__ofbU3","show_data_without_description":"inAppMessage_show_data_without_description__i4S4C"};